var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.301,
    height: 58.301,
    viewBox: "0 0 58.301 58.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_232",
    x: 0,
    y: 0,
    width: 58.301,
    height: 58.301,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17917",
    "data-name": "Group 17917",
    transform: "translate(-213.85 -564.85)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 213.85, 564.85)",
    filter: "url(#Ellipse_232)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_232-2",
    "data-name": "Ellipse 232",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(9.15 6.15)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "apple",
    transform: "translate(197.664 581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17914",
    "data-name": "Group 17914",
    transform: "translate(45.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17913",
    "data-name": "Group 17913"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36873",
    "data-name": "Path 36873",
    d: "M251.476,0a4.548,4.548,0,0,0-2.945,1.594,3.95,3.95,0,0,0-.964,3.07,3.839,3.839,0,0,0,2.972-1.518A4.265,4.265,0,0,0,251.476,0Z",
    transform: "translate(-247.522)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17916",
    "data-name": "Group 17916",
    transform: "translate(37.336 4.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17915",
    "data-name": "Group 17915"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36874",
    "data-name": "Path 36874",
    d: "M53.331,121.806a4.906,4.906,0,0,0-3.7-1.966c-1.738,0-2.474.832-3.681.832-1.245,0-2.191-.83-3.695-.83a5.027,5.027,0,0,0-4.046,2.446c-1.4,2.173-1.162,6.259,1.11,9.74.813,1.245,1.9,2.646,3.318,2.658,1.263.012,1.62-.81,3.331-.819s2.036.83,3.3.816c1.421-.011,2.566-1.563,3.379-2.808a13.966,13.966,0,0,0,1.251-2.35A4.273,4.273,0,0,1,53.331,121.806Z",
    transform: "translate(-37.336 -119.84)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleicon);
export default __webpack_public_path__ + "static/media/appleicon.dfd84fd730346bf23eb1cc43f19a6b70.svg";
export { ForwardRef as ReactComponent };